import { Fade, IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../localization'
import { Gateway } from '../../types/gateway'
import GatewayRowSkeleton from './GatewayRow.skeleton'
import GatewayRowDesktop from './GatewayRowDesktop'
import useStyles from './styles/GatewayTable.styles'

interface GatewayListDesktopProps {
  data: Gateway[]
  loading: boolean
  reloadData: () => void
  hasAccessToViewGateway: boolean | undefined
}

const GatewaysTable: React.FC<GatewayListDesktopProps> = ({
  data,
  loading,
  reloadData,
  hasAccessToViewGateway
}) => {
  const classes = useStyles()
  return (
    <div>
      <div className={classes.tableHead}>
        <div>
          <Typography variant="body1">{getTranslate('Name')}</Typography>
        </div>
        <div>
          <Typography variant="body1">
            {getTranslate('Gateway Type')}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Entity Type')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Entity Name')}</Typography>
        </div>
        <div className={classes.refreshButtonContainer}>
          <IconButton
            onClick={() => {
              reloadData()
            }}>
            <RefreshIcon />
          </IconButton>
        </div>
      </div>
      {loading
        ? Array(5)
            .fill('')
            .map((item, index) => (
              <GatewayRowSkeleton
                key={`accommodation-skeleton${item}${index.toString()}`}
              />
            ))
        : data.map((singleGateway: Gateway) => (
            <Fade in timeout={600} key={singleGateway.basicDetails.gatewayId}>
              <GatewayRowDesktop
                hasAccessToViewGateway={hasAccessToViewGateway}
                data={singleGateway}
              />
            </Fade>
          ))}
    </div>
  )
}
export default GatewaysTable
